import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { mcpEndpoints } from '@/modules/mcp/constants';
import { mcpQueryKeys } from '@/modules/mcp/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

export const useDisconnectMcpMutation = () => {
  return useMutation({
    mutationFn: async (id: string) => {
      await fetchClient.DELETE(mcpEndpoints.connection, {
        params: { path: { id } },
      });
    },
    onSettled: invalidateQuery(mcpQueryKeys.connections()),
  });
};
